export default "__VITE_ASSET__f2b613a1__"